import { Component } from '@angular/core';
import { Header } from '../../components/header/header';

@Component({
  selector: 'app-privacy-policy',
  imports: [Header],
  templateUrl: './privacy-policy.html',
  styleUrl: './privacy-policy.scss',
})
export class PrivacyPolicy {

}
